<template>
  <!-- 2 * roundedRadius <= length && 2 * channelWidth <= width -->
    <g 
      :transform="transform"    
      v-if="2 * roundedRadius <= length && 2 * channelWidth <= width"
    >
      <rect
        :x="x1 + roundedRadius"
        :y="y - width / 2"
        :width="lengthReduced"
        :height="width"
      />
      <rect
        :x="x1"
        :y="y - widthReduced / 2"
        :width="length"
        :height="widthReduced"
      />
      <!-- rounded corners -->
      <circle
        :cx="x + 0.5 * lengthReduced"
        :cy="y + 0.5 * widthReduced"
        :r="roundedRadius"
        stroke="inherit"
      />
      <circle
        :cx="x - 0.5 * lengthReduced"
        :cy="y + 0.5 * widthReduced"
        :r="roundedRadius"
        stroke="inherit"
      />
      <circle
        :cx="x - 0.5 * lengthReduced"
        :cy="y - 0.5 * widthReduced"
        :r="roundedRadius"
        stroke="inherit"
      />
      <circle
        :cx="x + 0.5 * lengthReduced"
        :cy="y - 0.5 * widthReduced"
        :r="roundedRadius"
        stroke="inherit"
      />
    </g>
    
  </template>
  <script>
  import { Channel } from "@/library/channel";
  import { useContentStore } from "@/stores/content";
  import { useCoordinateStore } from "@/stores/coordinate";
  import { defineComponent, computed } from "vue";
  export default defineComponent({
    props: {
      element: {
        posOnSeg: Number,
        channelSegment: Object,
      },
      layer: String,
      hightlightOffset: {
        type: Number,
        default: 0
      }
    },
    setup(props) {
      const coordinate = useCoordinateStore();
      const contentStore = useContentStore();
      
      const channelWidth = computed(() => {
      if (props.element.posOnSeg >= 0) {
        const channel = contentStore.getElement(
          props.element.channelSegment.cid
        );
        if (channel instanceof Channel) {
          return channel.properties.channelWidth.value;
        }
      }
      return contentStore.defaultChannelWidth;
    });
      
      const vx = computed(
        () =>
          props.element.channelSegment.end.position[0] -
          props.element.channelSegment.start.position[0]
      );
      const vy = computed(
        () =>
          props.element.channelSegment.end.position[1] -
          props.element.channelSegment.start.position[1]
      );

      // (x, y) is center of the valve
      const x = computed(() => {
        return props.element.posOnSeg >= 0
          ? props.element.channelSegment.start.position[0] +
            vx.value * props.element.posOnSeg
          : coordinate.roundedGlobalCoords[0]
    });
      const y = computed(() =>
        props.element.posOnSeg >= 0
          ? props.element.channelSegment.start.position[1] +
            vy.value * props.element.posOnSeg
          : coordinate.roundedGlobalCoords[1]
      );

      const width = computed(() => props.element.properties.width.value);

      const length = computed(() => props.element.properties.length.value);
      const roundedRadius = computed(() => {
        if (length.value >= 2 * props.element.properties.roundedRadius.value && width.value >= props.element.properties.roundedRadius.value) {
          return props.element.properties.roundedRadius.value
        } else {
          return length.value < 2 * props.element.properties.roundedRadius.value ? length.value / 2 : width.value / 2;
        }
      });
      const widthReduced = computed(() => props.element.properties.width.value - 2 * roundedRadius.value);
      const lengthReduced = computed(() => props.element.properties.length.value - 2 * roundedRadius.value);
 
      const x1 = computed(() => x.value - 0.5 * length.value);
      const x2 = computed(() => x.value + 0.5 * length.value);
  
      const transform = computed(() => {
        return `rotate(${
          (props.element.posOnSeg >= 0
            ? Math.atan2(vy.value, vx.value) * 180
            : 0) / Math.PI
        } ${x.value} ${y.value})`;
      });
   
      return {
        x,
        y,
        x1,
        x2,
        channelWidth,
        contentStore,
        transform,
        width,
        length,
        roundedRadius,
        widthReduced,
        lengthReduced
      };
    }
  });
  </script>
  